<template>
  <div>
    <!--container-->
    <v-container>
      <!--tob bar-->
      <bar />
      <!--tob bar end-->

      <!--template-->
      <template>
        <!--alert box-->
        <v-alert
          text
          dense
          color="teal"
          icon="mdi-clock-fast"
          border="left"
          v-if="stateStatusmsg"
        >
          <div v-for="(resp, i) in stateResponse" :key="i">
            {{ resp }}
          </div>
        </v-alert>
        <!--alert box end-->

        <!---datatable -->
        <v-data-table
          :headers="headers"
          :items="states"
          :search="search"
          sort-by="name"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>STATE</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-btn color="black" dark class="mb-2" to="/state/add">
                NEW STATE
              </v-btn>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editState(item)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
        <!---datatable end-->
      </template>
      <!--template end-->
    </v-container>
    <!--container end-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import router from "../../router";
export default {
  name: "State",
  data: () => ({
    search: "",
    headers: [
      { text: "Actions", value: "actions", sortable: false },
      {
        text: "STATE",
        align: "start",
        sortable: true,
        value: "name"
      },
      {
        text: "COUNTRY",
        align: "start",
        sortable: true,
        value: "country_name"
      },
      
    ]
  }),

  computed: {
    ...mapGetters(["stateList", "stateStatus", "stateStatusResponse"]),
    states: function() {
      return this.stateList;
    },
    stateStatusmsg: function() {
      return this.stateStatus === "success";
    },
    stateResponse: function() {
      return this.stateStatusResponse;
    }
  },

  watch: {},

  created() {
    this.fetchStates();
  },

  methods: {
    ...mapActions(["fetchStates"]),

    editState(item) {
      const id = item.id;
      //  router.push({ name: 'ProductGroupEdit', params: { productgroupId: 123 }})
      router.push({ path: `/state/edit/${id}` });
    }
  }
};
</script>
